// liquid-pdp

const logPDP = false

if (!customElements.get('product-style')) {
  class ProductStyles extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info')
      this.addEventListener('change', (event) => {
        const target = event.target
        const isClearance = target.classList.contains('js-is-clearance')
        if (isClearance) {
          this.productInfo.dataset.productClearance = 'true'
        } else {
          this.productInfo.dataset.productClearance = 'false'
        }
        const label = target.parentNode
        if (label) {
          label.classList.add('loading')
          label.querySelector('.loading__spinner')?.classList.remove('hidden')
        }
        publish(PUB_SUB_EVENTS.onStyleChange, {
          data: {
            event,
            target,
            label,
          },
        })
      })
      this.initTallSwitch()
      this.initCompareModalButtons()
    }

    initTallSwitch() {
      const tallSwitch = this.querySelector('.js-length-switch')
      if (tallSwitch) {
        tallSwitch.addEventListener('click', () => {
          this.productInfo.dataset.alternateSelectorOpen = 'true'
          const nonCheckedInput = this.querySelector(
            `product-style.js-tall-equivalent input:not(:checked)`,
          )
          if (nonCheckedInput) {
            nonCheckedInput.click()
          }
        })
      }
    }

    initCompareModalButtons() {
      this.querySelectorAll('.js-open-modal').forEach((button) => {
        button.addEventListener('click', () => {
          const modalTrigger = button.querySelector('general-modal .js-modal-trigger')
          if (modalTrigger) {
            modalTrigger.click()
          }
        })
      })
    }
  }
  customElements.define('product-style', ProductStyles)
}

if (!customElements.get('product-pack-selector')) {
  class ProductPackSelector extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info')
      this.addEventListener('change', (event) => {
        const target = event.target
        const isClearance = target.classList.contains('js-is-clearance')
        if (isClearance) {
          this.productInfo.dataset.productClearance = 'true'
        } else {
          this.productInfo.dataset.productClearance = 'false'
        }
        const label = target.parentNode
        if (label) {
          label.classList.add('loading')
          label.querySelector('.loading__spinner')?.classList.remove('hidden')
        }
        publish(PUB_SUB_EVENTS.onPackSizeChange, {
          data: {
            event,
            target,
          },
        })
      })
    }
  }
  customElements.define('product-pack-selector', ProductPackSelector)
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    onVariantChangeUnsubscriber = undefined
    onStyleChangeUnsubscriber = undefined
    onPackColorsChangeUnsubscriber = undefined
    onPackChangeUnsubscriber = undefined
    onTypeChangeUnsubscriber = undefined
    abortController = null
    responseCache = new Map() // Cache to store responses
    preProcessHtmlCallbacks = []
    postProcessHtmlCallbacks = []
    allOptionsSelected = false
    firstLoadLimit = 9 // How many swatches to show by default
    firstLoadLimitClearance = 6 // How many clearance swatches to show by default

    constructor() {
      super()
    }

    connectedCallback() {
      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      )
      this.onStyleChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onStyleChange,
        this.handleStyleChange.bind(this),
      )
      this.onPackColorsChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onPackColorsChange,
        this.handleProductChange.bind(this),
      )
      this.onPackChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onPackSizeChange,
        this.handlePackSizeChange.bind(this),
      )
      this.onTypeChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onTypeChange,
        this.handleTypeChange.bind(this),
      )
      this.symbol = this.dataset.currencySymbol

      if (this.dataset.pdpType === 'page' && this.dataset.galleryLayout === 'grid') {
        this.header = document.querySelector('.main-nav__wrapper')
        this.announcementBar = document.querySelector('.new-announcement-bar__wrapper')
        this.pdpUi = this.querySelector('.liquid-pdp__ui')
        if (this.header && this.announcementBar && this.pdpUi) {
          window.addEventListener('scroll', this.stickyProductInfo.bind(this), { passive: true })
        }
      }

      if (document.querySelector('#insider-club-upsell')?.checked) {
        document.querySelector('product-form shopify-accelerated-checkout')?.classList.add('hidden')
      } else {
        document
          .querySelector('product-form shopify-accelerated-checkout')
          ?.classList.remove('hidden')
      }

      // Set up collapsible button click listener
      // this.setupCollapsibleButton()

      // Afterpay modal functionality
      this.setupPayLaterModal()

      // Setup custom pack button delegation (only for Pima products with setting enabled)
      const runDelegationForPima =
        (this.dataset.familyHandle === 'short-sleeve-pima-crew' ||
          this.dataset.familyHandle === 'short-sleeve-curved-hem-pima-crew' ||
          this.dataset.familyHandle === 'long-sleeve-classic-crew') &&
        this.dataset.hideSoldOutPacksOnPimaPdp === 'true'
      this.setupCustomPackButtonDelegation(runDelegationForPima)

      // Update 'All Curated Packs Sold Out' overlay
      this.updateCuratedPacksSoldOutOverlay()

      if (this.dataset.productId && RecentlyViewed) {
        RecentlyViewed.addProduct(this.dataset.productId, this.dataset.productCategory5)
      }
    }

    setupCustomPackButtonDelegation(runDelegationForPima) {
      // Use event delegation to handle "Build Your Own" button clicks
      // This ensures the listener works even when HTML is replaced
      if (runDelegationForPima) {
        this.addEventListener('click', (event) => {
          // Check for custom pack button
          const customPackButton = event.target.closest('.js-build-your-own-trigger')
          if (customPackButton) {
            event.preventDefault()
            const singleSelector = this.querySelector(
              'product-pack-selector input[data-size="Single"]',
            )
            if (singleSelector) {
              singleSelector.click()
            }
            return
          }
        })
      }

      this.addEventListener('click', (event) => {
        // Check for overlay "Build Your Own" trigger
        const overlayTrigger = event.target.closest('#all-sold-out-overlay__build-your-own-trigger')
        if (overlayTrigger) {
          event.preventDefault()
          const singleSelector = this.querySelector(
            'product-pack-selector input[data-size="Single"]',
          )
          if (singleSelector) {
            singleSelector.click()
          }
        }
      })
    }

    disconnectedCallback() {
      if (this.dataset.pdpType === 'page') {
        window.removeEventListener('scroll', this.stickyProductInfo.bind(this))
      }
    }

    stickyProductInfo() {
      this.stickyTop = this.header.clientHeight + this.announcementBar.clientHeight
      this.style.setProperty('--pdp-info-sticky-top', `${this.stickyTop}px`)
      if (window.innerWidth >= 1200 && this.dataset.galleryLayout === 'grid') {
        this.classList.add('is-sticky')
      } else {
        this.classList.remove('is-sticky')
      }
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (logPDP) console.log('%c handleOptionValueChange', 'color: limegreen;')

      if (!this.contains(event.target)) return

      // Update the corresponding size display
      const optionGroup = target.closest('.liquid-pdp__variant-selector-buttons')
      if (optionGroup) {
        const header = optionGroup.previousElementSibling
        if (header) {
          const sizeDisplay = header.querySelector('.js-selected-size-display')
          if (sizeDisplay) {
            if (target.value === 'XS' || target.value === 'XSM') {
              sizeDisplay.textContent = 'X-Small'
            } else if (target.value === 'S' || target.value === 'SM') {
              sizeDisplay.textContent = 'Small'
            } else if (target.value === 'M' || target.value === 'MD') {
              sizeDisplay.textContent = 'Medium'
            } else if (target.value === 'L' || target.value === 'LG') {
              sizeDisplay.textContent = 'Large'
            } else if (target.value === 'XL' || target.value === 'XLG') {
              sizeDisplay.textContent = 'X-Large'
            } else if (target.value === '2XL' || target.value === '2XLG') {
              sizeDisplay.textContent = '2X-Large'
            } else if (target.value === '3XL' || target.value === '3XLG') {
              sizeDisplay.textContent = '3X-Large'
            } else if (target.value === '4XL' || target.value === '4XLG') {
              sizeDisplay.textContent = '4X-Large'
            } else {
              sizeDisplay.textContent = target.value
            }
          }
        }
      }

      const checkedProduct = this.querySelector('product-colors input:checked')
      if (!checkedProduct) return
      const productId = Number(checkedProduct.dataset.productId)

      let productFound = this.jsonData.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this.jsonData.singles_data_json.find((product) => product.id === productId)
      }

      if (this.dataset.noPdpAppData === 'true') {
        const productUrl = this.dataset.url
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, false, null),
          callback: this.handleDataUpdateBig(productUrl),
        })
      } else {
        this.updateFormState(productFound)
        this.updateProductGalleryPosition(productFound)
        if (this.dataset.isVarietyPacks === 'true') return
      }

      this.updateCuratedPacksSoldOutOverlay()
      document.dispatchEvent(new Event('sizeChanged'))
    }

    handleStyleChange({ data: { event, target, label } }) {
      if (logPDP) console.log('%c handleStyleChange', 'color: limegreen;')

      if (!this.contains(event.target)) return

      const productUrl = target.value
      const productId = Number(target.dataset.productId)
      const variantId = this.keepSize(productId)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleDataUpdateBig(productUrl, 'style', label, target),
      })

      const styleOption = target.name.split('-')[1]
      const styleValue = label.dataset.value

      document.dispatchEvent(
        new CustomEvent('product-style-updated', { detail: { styleOption, styleValue } }),
      )
    }

    handleTypeChange({ data: { event, target } }) {
      if (logPDP) console.log('%c handleTypeChange', 'color: limegreen;')

      if (!this.contains(event.target)) return

      const productUrl = target.value
      const productId = Number(target.dataset.productId)
      const variantId = this.keepSize(productId)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleDataUpdateBig(productUrl),
      })
    }

    handleProductChange({ data: { event, target } }) {
      if (!this.contains(event.target)) return

      const productId = Number(target.dataset.productId)

      let productFound = this.jsonData.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this.jsonData.singles_data_json.find((product) => product.id === productId)
      }
      if (!productFound) return

      if (window.hideFomoBadge) hideFomoBadge()

      this.dataset.productId = Number(target.dataset.productId)
      this.dataset.productHandle = target.value
      this.dataset.colorPack = target.dataset.colorPack

      if (target.classList.contains('js-is-clearance')) {
        this.dataset.productClearance = true
      } else {
        this.dataset.productClearance = false
      }

      if (this.dataset.isVarietyPacks == 'true') {
        this.updateProductTitleFromJsonData(productFound)
      }

      // Update product price with input data
      this.updateProductPriceFromInputData(target)

      // Update color list
      this.updateColorList(target.dataset.colorList)

      // Update gallery slides
      this.updateGallery(productFound)

      const productUrl = target.value
      const variantId = this.keepSize(productId)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleDataUpdate(),
      })

      this.updateFormState(productFound)

      this.sendDataLayerInfo()

      this.updateProductGalleryPosition(productFound)

      if (this.dataset.productId && RecentlyViewed) {
        RecentlyViewed.addProduct(this.dataset.productId, this.dataset.productCategory5)
      }

      // checkShortSize()
      document.dispatchEvent(new CustomEvent('colorChanged'))
    }

    handlePackSizeChange({ data: { event, target } }) {
      if (logPDP) console.log('%c handlePackSizeChange', 'color: limegreen;')

      if (!this.contains(event.target)) return

      const productUrl = target.value
      const productId = Number(target.dataset.productId)
      const variantId = this.keepSize(productId)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleDataUpdateBig(productUrl),
      })
    }

    changeFullSection(productUrl, updateUrl = true) {
      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, null),
        callback: this.handleUpdateFullProductInfo(productUrl, updateUrl),
      })
    }

    renderProductInfo({ requestUrl, callback }) {
      this.abortController?.abort()
      this.abortController = new AbortController()

      // Check if we have a cached response
      if (this.responseCache.has(requestUrl)) {
        const cachedHtml = this.responseCache.get(requestUrl)
        callback(cachedHtml)
        return
      }

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          // Store the parsed HTML in cache
          this.responseCache.set(requestUrl, html)
          callback(html)
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.error('Fetch aborted by user')
            this.querySelectorAll('label').forEach((label) => {
              label.classList.remove('loading')
            })
            this.querySelectorAll('.loading__spinner').forEach((spinner) => {
              spinner.classList.add('hidden')
            })
          } else {
            console.error(error)
          }
        })
    }

    handleDataUpdate() {
      if (logPDP) console.log('%c handleDataUpdate', 'color: limegreen;')

      this.querySelector('product-form').classList.add('loading')
      // this.productDescription.classList.add('loading')
      return (html) => {
        const updates = [
          () => (this.dataset.isVarietyPacks == 'false' ? this.updateProductTitle(html) : null),
          () =>
            this.dataset.isVarietyPacks == 'false' ? this.updateProductDescription(html) : null,
          () => (this.dataset.isVarietyPacks == 'true' ? this.updateProductPrice(html) : null),
          () => (this.dataset.isVarietyPacks == 'true' ? this.updateProductStarRating(html) : null),
          () =>
            this.dataset.isVarietyPacks == 'true' ? this.updateProductDescription(html) : null,
          () => this.updateProductPrice(html),
          () => this.updateProductInfoData(html),
          () => this.updateOptionValues(html).then(),
          () => this.updateSizeChartButton(html),
          () => this.updateSizeChartModal(html),
          () => this.updateAfterpay(html),
          () => this.updateDiscountBar(html),
          () => updateGalleryPromoText(html),
          () => this.updateBelowAtcModals(html),
          () => this.updatePackSelectors(html),
          () => this.updateUso(html),
          () => this.updateExpectedShipping(html),
          () => (!this.closest('quick-add-modal') ? this.updateRebuyRecommendations() : null),
        ]

        // Execute all updates
        updates.forEach((update) => update())
        this.querySelector('product-form').classList.remove('loading')
        // this.productDescription.classList.remove('loading')

        // Update view full details link on quick add modal
        const viewFullDetails = document.querySelector('.js-quick-modal-view-full-details')
        if (viewFullDetails) {
          if (this.dataset.country === 'US') {
            viewFullDetails.href = this.dataset.url
          } else {
            viewFullDetails.href = `/${this.dataset.locale.toLowerCase()}-${this.dataset.country.toLowerCase()}/products/${this.dataset.productHandle}`
          }
        }
      }
    }

    handleDataUpdateBig(productUrl, updateType = '', label = null, target = null) {
      if (logPDP) console.log('%c handleDataUpdateBig', 'color: limegreen;')

      this.querySelector('product-form').classList.add('loading')

      return (html) => {
        const variant = this.getSelectedVariant(html)

        const updates = [
          () => this.updateProductInfoData(html),
          () => this.updateURL(productUrl, variant?.id),
          () => this.updateProductTitle(html),
          () => this.updateProductDescription(html),
          () => this.updateProductPrice(html),
          () => this.updateDiscountBar(html),
          () => updateGalleryPromoText(html),
          () => (updateType === 'style' ? this.updateProductStarRating(html) : null),
          () => this.updateOptionValues(html).then(),
          () => this.updateVariantInputs(variant?.id),
          () => this.updateTallEquivalent(html),
          () => this.updateFamilySelector(html),
          () =>
            updateType === 'style'
              ? this.updateStyleSelectionWithJs(target)
              : this.updateStyleSelectors(html),
          () => this.updateColors(html),
          () => this.updateProductForm(html),
          () => this.updateBundleBuilderQuantitySelector(html),
          () => this.updateAfterpay(html),
          () => this.updateProductCustomPack(html),
          () => this.updatePackSelectors(html),
          () => this.updateUiFooter(html),
          () => this.updateBxgy(html),
          () => this.updateBelowPdpAppContent(html),
          () => this.updateModalWrapper(html),
          () => this.updatePdpProductContext(html),
          () => this.sendDataLayerInfo(),
          () => this.updateSizeChartButton(html),
          () => this.updateSizeChartModal(html),
          () => this.updateCompleteTheLook(html),
          () => this.updateExpectedShipping(html),
          () =>
            this.dataset.noPdpAppData === 'true' ? null : this.updateProductGalleryFromHtml(html),
          () => this.updateBelowAtcModals(html),
          () => this.updateAvailableInTarget(html),
          () => (updateType === 'style' ? this.updateOkendoReviews() : null),
          () => this.updateCuratedPacksSoldOutOverlay(),
          () => (window.hideFomoBadge ? hideFomoBadge() : null),
          () => (window.showLowStockBadge ? showLowStockBadge({ checkFirst: true }) : null),
          () => updateInsiderClubUpsell(html),
          () => (!this.closest('quick-add-modal') ? this.updateRebuyRecommendations() : null),
        ]

        updates.forEach((update) => update())
        this.querySelector('product-form').classList.remove('loading')

        // Update view full details link on quick add modal
        const viewFullDetails = document.querySelector('.js-quick-modal-view-full-details')
        if (viewFullDetails) {
          if (this.dataset.country === 'US') {
            viewFullDetails.href = this.dataset.url
          } else {
            viewFullDetails.href = `/${this.dataset.locale}-${this.dataset.country}/products/${this.dataset.productHandle}`
          }
        }
        // checkShortSize()

        if (label) {
          label.classList.remove('loading')
          label.querySelector('.loading__spinner')?.classList.add('hidden')
        }

        // logProductInfoDataAttributes()
      }
    }

    handleUpdateFullProductInfo(productUrl, updateUrl) {
      if (logPDP) console.log('%c handleUpdateFullProductInfo', 'color: limegreen;')

      this.querySelector('product-form').classList.add('loading')
      return (html) => {
        const variant = this.getSelectedVariant(html)
        const updates = [
          () => (updateUrl ? this.updateURL(productUrl, variant?.id) : null),
          () => this.updateFullProductInfo(html),
          () => this.updateBelowPdpAppContent(html),
          () => this.updateOkendoReviews(),
          () => (!this.closest('quick-add-modal') ? this.updateRebuyRecommendations() : null),
        ]
        updates.forEach((update) => update())
        this.querySelector('product-form').classList.remove('loading')
        document.dispatchEvent(new CustomEvent('product-info-updated'))
      }
    }

    findVariantFromOptions(selectedValues) {
      const productId = Number(this.dataset.productId)
      let productFound = this.jsonData.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this.jsonData.singles_data_json.find((product) => product.id === productId)
      }
      if (!productFound) return null

      return productFound.variants.find((variant) => {
        return selectedValues.every((value, index) => {
          return variant[`option${index + 1}`] === value
        })
      })
    }

    updateFormState(productFound) {
      const variantSelects = this.querySelector('variant-selects')
      if (!variantSelects) return

      // Get all required options
      const optionGroups = variantSelects.querySelectorAll(
        'variant-selects .liquid-pdp__variant-selector-buttons',
      )

      // Update dataset.selectedSize with all selected values
      const selectedInputs = Array.from(optionGroups)
        .map((group) => group.querySelector('input:checked'))
        .filter((input) => input !== null)
        .map((input) => input.value)

      this.dataset.selectedSize = selectedInputs.join(' / ')

      // Update form inputs
      const form = this.querySelector('product-form form')

      if (this.dataset.productPackSize === 'Single') {
        if (this.dataset.productClearance === 'true') {
          // Remove any existing property inputs first
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())

          // Add clearance-specific hidden inputs
          const clearanceInput = document.createElement('input')
          clearanceInput.type = 'hidden'
          clearanceInput.name = 'properties[_clearance]'
          clearanceInput.value = 'true'

          const typeInput = document.createElement('input')
          typeInput.type = 'hidden'
          typeInput.name = 'properties[_type]'
          typeInput.value =
            this.dataset.pageType === 'page'
              ? 'PDP'
              : this.dataset.pageType === 'popup'
                ? 'popup'
                : 'Bundle Builder'

          const preClearanceInput = document.createElement('input')
          preClearanceInput.type = 'hidden'
          preClearanceInput.name = 'properties[_pre_clearance_price]'
          preClearanceInput.value = this.dataset.productCompareAtPriceFormatted || ''

          form.appendChild(clearanceInput)
          form.appendChild(typeInput)
          form.appendChild(preClearanceInput)
        } else {
          // Remove any existing property inputs first
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())

          // Add value builder hidden inputs
          const valueBuilderInput = document.createElement('input')
          valueBuilderInput.type = 'hidden'
          valueBuilderInput.name = 'properties[_value_builder]'
          valueBuilderInput.value = 'true'

          const typeInput = document.createElement('input')
          typeInput.type = 'hidden'
          typeInput.name = 'properties[_type]'
          typeInput.value =
            this.dataset.pageType === 'page'
              ? 'PDP'
              : this.dataset.pageType === 'popup'
                ? 'popup'
                : 'Bundle Builder'

          form.appendChild(valueBuilderInput)
          form.appendChild(typeInput)
        }
      } else {
        // Remove all property inputs when not Single
        if (form) {
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())
        }
      }

      this.allOptionsSelected = selectedInputs.length === optionGroups.length

      // Update form button
      const submitButton = this.querySelector('product-form form button[type="submit"]')
      const submitButtonText = submitButton.querySelector('.js-button-text')

      if (!this.allOptionsSelected) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.selectSizeText
        this.updateURL(this.dataset.productHandle, '')
        this.updateProductInfoDataFromJsonData(productFound)
        return
      }

      // If all options are selected, check if the variant exists and is available
      const selectedVariant = this.findVariantFromOptions(selectedInputs)

      if (!selectedVariant) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.unavailableText
        this.dataset.productAvailable = false
        this.updateProductInfoDataFromJsonData(productFound)
        return
      }

      this.dataset.variantId = selectedVariant.id
      this.dataset.sku = selectedVariant.sku
      this.dataset.lowStockVariant = selectedVariant.low_stock
      const formInput = this.querySelector('product-form form input[name="id"]')
      formInput.value = selectedVariant.id
      formInput.disabled = !selectedVariant.available
      this.updateURL(this.dataset.productHandle, selectedVariant.id)

      this.updateProductInfoDataFromJsonData(productFound, selectedVariant)

      if (window.hideFomoBadge) hideFomoBadge()
      if (selectedVariant.low_stock && window.showLowStockBadge)
        showLowStockBadge({ checkFirst: false })

      if (!selectedVariant.available) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.soldOutText
        this.dataset.productAvailable = false

        // Update Klaviyo form variant ID
        const klaviyoForm = this.querySelector('klaviyo-notify-me')
        if (klaviyoForm) {
          const variantIdInput = klaviyoForm.querySelector('input[name="variant_id"]')
          if (variantIdInput) {
            variantIdInput.value = selectedVariant.id
          }
          const formButton = klaviyoForm.querySelector('button[type="submit"]')
          if (formButton) {
            formButton.dataset.productId = this.dataset.productId
            formButton.dataset.variantId = selectedVariant.id
            formButton.dataset.productTitle = this.dataset.productTitle
            formButton.dataset.productUrl = this.dataset.url
          }
        }
        if (this.dataset.isVarietyPacks == 'false') {
          this.updateProductAvailableState(productFound)
        }
        return
      }

      // Enable the button if we have a valid, available variant
      submitButton.disabled = false
      submitButtonText.innerHTML = submitButton.dataset.addToCartText
      this.dataset.productAvailable = true

      if (this.dataset.isVarietyPacks == 'false') {
        this.updateProductAvailableState(productFound)
      }

      this.sendDataLayerInfo()
    }

    updateProductAvailableState(productFound) {
      const productFoundOptionsSize = productFound.options?.length
      const variantSelects = this.querySelector('variant-selects')
      if (!variantSelects) return

      // Get all checked inputs with their names and values
      const selectedOptions = {}
      variantSelects.querySelectorAll('input:checked').forEach((input) => {
        selectedOptions[input.name] = input.value
      })

      // For each color input, check if it has the exact option combination
      this.querySelectorAll('product-colors input').forEach((input) => {
        const colorProductId = Number(input.dataset.productId)
        let productFound = this.jsonData.packs_data_json.find(
          (product) => product.id === colorProductId,
        )
        if (!productFound) {
          productFound = this.jsonData.singles_data_json.find(
            (product) => product.id === colorProductId,
          )
        }
        if (!productFound) return

        const variantFound = productFound.variants.find(
          (variant) => variant.title === this.dataset.selectedSize,
        )
        if (!variantFound) {
          // Apply disabled class if the product has the same number of options as the selected size
          if (productFoundOptionsSize === productFound.options?.length) {
            input.classList.add('disabled')
            input.dataset.disabled = 'true'
          }
          return
        }

        const variantAvailable = variantFound.available
        if (variantAvailable) {
          input.classList.remove('disabled')
          input.dataset.disabled = 'false'
        } else {
          input.classList.add('disabled')
          input.dataset.disabled = 'true'
        }
      })

      // Check if currently selected pack is now disabled, and switch to first available pack (Pima only with setting enabled)
      if (
        (this.dataset.familyHandle === 'short-sleeve-pima-crew' ||
          this.dataset.familyHandle === 'short-sleeve-curved-hem-pima-crew' ||
          this.dataset.familyHandle === 'long-sleeve-classic-crew') &&
        this.dataset.hideSoldOutPacksOnPimaPdp === 'true'
      ) {
        const currentlySelectedInput = this.querySelector('product-colors input:checked')
        if (currentlySelectedInput && currentlySelectedInput.classList.contains('disabled')) {
          // Find first non-disabled pack input (excluding custom pack button)
          const firstAvailableInput = this.querySelector(
            'product-colors .liquid-pdp__product-colors-button-wrapper:not(.custom-pack-button-wrapper) input:not(.disabled)',
          )
          if (firstAvailableInput) {
            firstAvailableInput.click()
          }
        }
      }

      // Reorder labels within each wrapper based on their input's disabled state
      const productColors = this.querySelector('product-colors')
      if (productColors) {
        const swatchesWrappers = productColors.querySelectorAll(
          '.liquid-pdp__product-color-swatches-wrapper',
        )
        swatchesWrappers.forEach((wrapper) => {
          // Order labels by their input's disabled state
          const labels = Array.from(wrapper.querySelectorAll('label'))
          labels.sort((a, b) => {
            const aDisabled = a.querySelector('input').classList.contains('disabled')
            const bDisabled = b.querySelector('input').classList.contains('disabled')
            return Number(aDisabled) - Number(bDisabled)
          })
          labels.forEach((label, index) => {
            if (label.querySelector('input').classList.contains('js-is-clearance')) {
              if (index < this.firstLoadLimitClearance) {
                label.classList.remove('liquid-pdp__product-color-swatch--hidden')
              } else {
                label.classList.add('liquid-pdp__product-color-swatch--hidden')
              }
            } else {
              if (index < this.firstLoadLimit) {
                label.classList.remove('liquid-pdp__product-color-swatch--hidden')
              } else {
                label.classList.add('liquid-pdp__product-color-swatch--hidden')
              }
            }
            wrapper.appendChild(label)
          })
          // Send button to the end of the wrapper
          const button = wrapper.querySelector('.liquid-pdp__singles-swatches__toggle')
          if (button) wrapper.appendChild(button)

          this.checkNumberOfVisibleSwatches(labels, wrapper)
        })
      }

      handleNotReturningSwatches()
    }

    updateProductGalleryPosition(productFound) {
      const variantFound = productFound.variants.find(
        (variant) => variant.title === this.dataset.selectedSize,
      )
      if (!variantFound) return
      const selectedVariantImagePosition = variantFound.featured_image_position
      if (!selectedVariantImagePosition) return
      this.productGallery.goToPosition(selectedVariantImagePosition)
    }

    checkNumberOfVisibleSwatches(labels, wrapper) {
      if (!wrapper) return

      let visibleLabelsCount = 0
      let invisibleLabelsCount = 0
      labels.forEach((label) => {
        if (window.getComputedStyle(label).display === 'none') {
          invisibleLabelsCount++
        } else {
          visibleLabelsCount++
        }
      })
      if (visibleLabelsCount < this.firstLoadLimit && invisibleLabelsCount > 0) {
        wrapper.querySelector('.liquid-pdp__singles-swatches__toggle').classList.add('hide')
        if (!wrapper.classList.contains('showing-all-swatches')) {
          wrapper.classList.add('showing-all-swatches')
        }
      } else {
        wrapper.querySelector('.liquid-pdp__singles-swatches__toggle')?.classList.remove('hide')
      }
    }

    updateColorList(colorList) {
      const colorDisplay = this.querySelector('#color-display')
      if (colorDisplay) {
        colorDisplay.dataset.colorList = colorList
        const productColors = this.querySelector('product-colors')
        if (productColors) {
          productColors.setupToggleColors()
        }
      }
    }

    updateGallery(productFound) {
      // console.log('updateGallery', productFound.carousel_video, this.jsonData.video_data)
      const gallery = this.querySelector('product-gallery')
      if (gallery && productFound.media && productFound.media.length > 0) {
        gallery.updateGalleryMedia(
          productFound.media,
          productFound.carousel_video,
          this.jsonData.video_data,
          productFound.media_test,
        )
      }
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector(
        'variant-selects [data-selected-variant]',
      )?.innerHTML
      return !!selectedVariant ? JSON.parse(selectedVariant) : null
    }

    updateOptionValues(html) {
      return new Promise((resolve) => {
        const variantSelects = html.querySelector('variant-selects')

        if (variantSelects && this.variantSelectors) {
          // Save the size options wrapper before update
          const existingSizeOptions = this.variantSelectors.querySelector('.size-options-wrapper')

          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, [])

          // If there was a size options wrapper, restore it
          if (existingSizeOptions) {
            const newSizeOptionsWrapper =
              this.variantSelectors.querySelector('.size-options-wrapper')
            if (newSizeOptionsWrapper) {
              newSizeOptionsWrapper.replaceWith(existingSizeOptions)
            }
          }
        }
        resolve()
      })
    }

    updateColors(html) {
      if (this.dataset.isVarietyPacks == 'true') {
        return
      }
      const productColors = html.querySelector('product-colors')
      if (productColors && this.productColors) {
        HTMLUpdateUtility.viewTransition(this.productColors, productColors, [])
      }
    }

    updateColorsWithJsonData(html) {
      const colorsWays = html.querySelector('product-colors #color-display')
      const oldColorsWays = this.productColors.querySelector('#color-display')
      if (colorsWays && this.productColors.querySelector('#color-display')) {
        HTMLUpdateUtility.viewTransition(oldColorsWays, colorsWays, [])
      }
      const selectedSize = this.selectedSize
      if (!selectedSize) return
      const singlesDataJson = this.jsonData.singles_data_json
      if (!singlesDataJson) return
      singlesDataJson.forEach((product) => {
        const productHandle = product.handle
        const foundColorInput = this.querySelector(`product-colors input[value="${productHandle}"]`)
        if (!foundColorInput) return
        const foundVariant = product.variants.find((variant) => variant.title === selectedSize)
        if (!foundVariant) return
        if (foundVariant.available) {
          foundColorInput.classList.remove('disabled')
        } else {
          foundColorInput.classList.add('disabled')
        }
      })
    }

    updateFamilySelector(html) {
      const productStyle = html.querySelector('product-style.family-selector')
      if (productStyle) {
        HTMLUpdateUtility.viewTransition(this.productFamily, productStyle, [])
      }
    }

    updateStyleSelectors(html) {
      const productStyles = html.querySelectorAll('product-style[data-style]')
      if (productStyles.length > 0) {
        productStyles.forEach((productStyle) => {
          const productStyleHandle = productStyle.dataset.style
          const thisProductStyle = this.querySelector(
            `product-style[data-style="${productStyleHandle}"]`,
          )
          if (productStyleHandle && thisProductStyle) {
            HTMLUpdateUtility.viewTransition(thisProductStyle, productStyle, [])
          }
        })
      }
    }

    updatePackSelectors(html) {
      const packSelectors = html.querySelector('product-pack-selector')
      if (packSelectors && this.packSelectors) {
        HTMLUpdateUtility.viewTransition(this.packSelectors, packSelectors, [])
      }
    }

    updateProductTitle(html) {
      const productTitle = html.querySelector('.js-product-title')
      if (productTitle && this.productTitle) {
        HTMLUpdateUtility.viewTransition(this.productTitle, productTitle, [])
      }
    }

    updateProductDescription(html) {
      const productDescription = html.querySelector('.js-product-description')
      if (productDescription && this.productDescription) {
        HTMLUpdateUtility.viewTransition(this.productDescription, productDescription, [])
      }
    }

    updateProductTitleFromJsonData(productFound) {
      const productTitle = this.querySelector('.js-product-title')
      if (productTitle) {
        productTitle.innerHTML = productFound.title
      }
    }

    updateProductInfoDataFromJsonData(productFound = null, selectedVariant = null) {
      if (logPDP) console.log('%c updateProductInfoDataFromJsonData', 'color: limegreen;')

      if (productFound) {
        this.dataset.productId = productFound.id
        this.dataset.url = `/products/${productFound.handle}`
        this.dataset.productHandle = productFound.handle
        this.dataset.productTitle = productFound.title
      }
      if (selectedVariant) {
        this.dataset.variantId = selectedVariant.id
        this.dataset.sku = selectedVariant.sku
        this.dataset.lowStockVariant = selectedVariant.low_stock
      }
    }

    updateProductInfoData(html) {
      if (logPDP) console.log('%c updateProductInfoData', 'color: limegreen;')

      const productInfo = html.querySelector('product-info')
      if (productInfo) {
        this.dataset.productAvailable = productInfo.dataset.productAvailable
        this.dataset.productPackSize = productInfo.dataset.productPackSize
        this.dataset.membershipStatus = productInfo.dataset.membershipStatus
        this.dataset.customerId = productInfo.dataset.customerId
        this.dataset.colorPack = productInfo.dataset.colorPack
        this.dataset.loginStatus = productInfo.dataset.loginStatus
        this.dataset.packQuantity = productInfo.dataset.packQuantity
        this.dataset.ecommerceCurrency = productInfo.dataset.ecommerceCurrency
        this.dataset.productPrice = productInfo.dataset.productPrice
        this.dataset.productPriceFormatted = productInfo.dataset.productPriceFormatted
        this.dataset.productCompareAtPrice = productInfo.dataset.productCompareAtPrice
        this.dataset.productCompareAtPriceFormatted =
          productInfo.dataset.productCompareAtPriceFormatted
        this.dataset.productId = productInfo.dataset.productId
        this.dataset.productTitle = productInfo.dataset.productTitle
        this.dataset.productDiscount = productInfo.dataset.productDiscount
        this.dataset.productBrand = productInfo.dataset.productBrand
        this.dataset.productCategory = productInfo.dataset.productCategory
        this.dataset.productCategory2 = productInfo.dataset.productCategory2
        this.dataset.productCategory3 = productInfo.dataset.productCategory3
        this.dataset.productCategory5 = productInfo.dataset.productCategory5
        this.dataset.sku = productInfo.dataset.sku
        this.dataset.lowStockVariant = productInfo.dataset.lowStockVariant
        this.dataset.variantId = productInfo.dataset.variantId
        this.dataset.isWeeklyDeal = productInfo.dataset.isWeeklyDeal
        this.dataset.productClearance = productInfo.dataset.productClearance

        // update dataset entries that start with 'style'
        const entries = Object.entries(productInfo.dataset).filter(([k]) => k.startsWith('style'))
        entries.forEach(([k, v]) => (this.dataset[k] = v))

        updateInsiderClubUpsell(html)
        updateCashbackMessage(html)

        if (this.bxgyPrice) {
          const space = currencySymbol === 'MX$' ? ' ' : ''
          this.bxgyPrice.textContent = `${currencySymbol}${space}${Number(productInfo.dataset.productPrice).toFixed(2)}`
        }

        if (document.querySelector('#insider-club-upsell')?.checked) {
          document
            .querySelector('product-form shopify-accelerated-checkout')
            ?.classList.add('hidden')
        } else {
          document
            .querySelector('product-form shopify-accelerated-checkout')
            ?.classList.remove('hidden')
        }

        if (window.isMultiFamilyLp === true) {
          this.dataset.updateUrl = false
        } else {
          this.dataset.updateUrl = true
        }
      }
    }

    updateProductStarRating(html) {
      const productStarRating = html.querySelector('.js-product-star-rating')
      if (productStarRating && this.productStarRating) {
        HTMLUpdateUtility.viewTransition(this.productStarRating, productStarRating, [])
      }
    }

    updateProductPrice(html) {
      const productPrice = html.querySelector('.js-product-price')
      if (productPrice && this.productPrice) {
        HTMLUpdateUtility.viewTransition(this.productPrice, productPrice, [])
      }
    }

    updateDiscountBar(html) {
      const discountBar = html.querySelector('discount-bar')

      if (discountBar && this.discountBar) {
        HTMLUpdateUtility.viewTransition(this.discountBar, discountBar, [], [])
      }
    }

    updateCollapsibleWrapper(html) {
      const collapsibleWrapper = html.querySelector('.liquid-pdp__collapsible-wrapper')
      if (collapsibleWrapper && this.collapsibleWrapper) {
        HTMLUpdateUtility.viewTransition(this.collapsibleWrapper, collapsibleWrapper, [])
      }
    }

    updateProductForm(html) {
      const productForm = html.querySelector('product-form')
      if (productForm && this.productForm) {
        HTMLUpdateUtility.viewTransition(this.productForm, productForm, [])
      }
    }

    updateAfterpay(html) {
      const afterpay = html.querySelector('.afterpay-widget')
      if (afterpay && this.afterpay) {
        HTMLUpdateUtility.viewTransition(this.afterpay, afterpay, [])
      }
    }

    updatePdpProductContext(html) {
      const pdpProductContext = html.querySelector('pdp-product-context')
      if (pdpProductContext && this.pdpProductContext) {
        HTMLUpdateUtility.viewTransition(this.pdpProductContext, pdpProductContext, [])
      }
    }

    updateUso(html) {
      const productUso = html.querySelector('product-uso')
      if (productUso && this.productUso) {
        HTMLUpdateUtility.viewTransition(this.productUso, productUso, [])
      }
    }

    updateProductGalleryFromHtml(html) {
      updateGalleryPromoText(html)
      const productGallery = html.querySelector('product-gallery')
      if (productGallery && this.productGallery) {
        this.productGallery.updateGallery(productGallery)
      }
    }

    updateTallEquivalent(html) {
      const tallEquivalent = html.querySelector('.js-tall-equivalent')
      if (tallEquivalent && this.tallEquivalent) {
        HTMLUpdateUtility.viewTransition(this.tallEquivalent, tallEquivalent, [])
      }
    }

    updateBelowPdpAppContent(html) {
      const oldBelowPdpAppContent = this.belowPdpAppContent
      const newBelowPdpAppContent = html.querySelector('below-pdp-app-content')

      if (newBelowPdpAppContent && oldBelowPdpAppContent) {
        HTMLUpdateUtility.viewTransition(oldBelowPdpAppContent, newBelowPdpAppContent, [])
      }
    }

    updateModalWrapper(html) {
      const modalWrapper = html.querySelector('.pdp-modal-wrapper')
      if (modalWrapper && this.modalWrapper) {
        HTMLUpdateUtility.viewTransition(this.modalWrapper, modalWrapper, [])
      }
    }

    updateVariantInputs(variantId) {
      this.querySelectorAll(`#product-form-${this.dataset.section}`).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]')
        input.value = variantId ?? ''
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    }

    updateURL(url, variantId) {
      if (this.dataset.updateUrl === 'false') return

      const finalUrl = this.constructProductUrl(url)
      this.dataset.url = finalUrl
      window.history.replaceState({}, '', `${finalUrl}${variantId ? `?variant=${variantId}` : ''}`)
    }

    constructProductUrl(url) {
      // Normalize the current pathname by removing trailing slashes
      const normalizedPathname = window.location.pathname.replace(/\/+$/, '')

      // Check if the URL already contains a full path
      if (url.includes('/products/')) {
        return url
      }

      // If we're on a product page, replace the current product with the new one
      if (normalizedPathname.includes('/products/')) {
        // Extract the base path (everything before the last product handle)
        const pathParts = normalizedPathname.split('/')
        const productsIndex = pathParts.indexOf('products')
        if (productsIndex !== -1 && productsIndex < pathParts.length - 1) {
          // Remove the current product handle and add the new one
          const basePath = pathParts.slice(0, productsIndex + 1).join('/')
          return `${basePath}/${url}`
        }
        // Fallback: construct from root
        return `${normalizedPathname.replace(/\/products\/[^\/]+$/, '')}/products/${url}`
      }

      // Not on a product page, construct the product URL from root
      return `/products/${url}`
    }

    updateUiFooter(html) {
      const uiFooter = html.querySelector('.js-liquid-pdp__ui-footer')
      if (uiFooter && this.uiFooter) {
        HTMLUpdateUtility.viewTransition(this.uiFooter, uiFooter, [])
      }
    }

    updateProductCustomPack(html) {
      const productCustomPack = html.querySelector('product-custom-pack')
      if (productCustomPack && this.productCustomPack) {
        HTMLUpdateUtility.viewTransition(this.productCustomPack, productCustomPack, [])
      }
    }

    updateBxgy(html) {
      const bxgyWrapper = html.querySelector('.js-bxgy-wrapper')
      if (bxgyWrapper && this.bxgyWrapper) {
        HTMLUpdateUtility.viewTransition(this.bxgyWrapper, bxgyWrapper, [])
      }
    }

    updateSizeChartButton(html) {
      const sizeChartButton = html.querySelector('.js-size-chart-button-wrapper')
      if (sizeChartButton && this.sizeChartButton) {
        HTMLUpdateUtility.viewTransition(this.sizeChartButton, sizeChartButton, [])
      }
    }

    updateSizeChartModal(html) {
      const sizeChartModal = html.querySelector('size-chart-modal')
      if (sizeChartModal && this.sizeChartModal) {
        HTMLUpdateUtility.viewTransition(this.sizeChartModal, sizeChartModal, [])
      }
    }

    updateAvailableInTarget(html) {
      const availableInTarget = html.querySelector('available-in-target')
      if (availableInTarget && this.availableInTarget) {
        HTMLUpdateUtility.viewTransition(this.availableInTarget, availableInTarget, [])
      }
    }

    async updateOkendoReviews() {
      const okendoReviews = document.querySelector('okendo-reviews')
      if (okendoReviews) {
        await okendoReviews.updateReviews()
        updateOkendoReviewsRecommendations()
      }
    }

    updateRebuyRecommendations() {
      const rebuyRecommendations = document.querySelector('rebuy-recommendations')
      if (rebuyRecommendations) {
        rebuyRecommendations.dataset.productId = this.dataset.productId
        rebuyRecommendations.fetchRecommendations()
      }
    }

    updateProductDescription(html) {
      const productDescription = html.querySelector('.js-product-description')
      if (productDescription && this.productDescription) {
        HTMLUpdateUtility.viewTransition(this.productDescription, productDescription, [])
      }
    }

    updateCompleteTheLook(html) {
      const completeTheLook = html.querySelector('.js-complete-the-look')
      if (completeTheLook && this.completeTheLook) {
        HTMLUpdateUtility.viewTransition(this.completeTheLook, completeTheLook, [])
      }
    }

    updateExpectedShipping(html) {
      const expectedShipping = html.querySelector('.js-expected-shipping')
      if (expectedShipping && this.expectedShipping) {
        HTMLUpdateUtility.viewTransition(this.expectedShipping, expectedShipping, [])
      }
    }

    updateBundleBuilderQuantitySelector(html) {
      const bundleBuilderQuantitySelector = html.querySelector('bundle-builder-quantity-selector')
      if (bundleBuilderQuantitySelector && this.bundleBuilderQuantitySelector) {
        HTMLUpdateUtility.viewTransition(
          this.bundleBuilderQuantitySelector,
          bundleBuilderQuantitySelector,
          [],
        )
      }
    }

    updateFullProductInfo(html) {
      if (logPDP) console.log('%c updateFullProductInfo', 'color: limegreen;')

      const fullProductInfo = html.querySelector('product-info')
      if (fullProductInfo) {
        HTMLUpdateUtility.viewTransition(this, fullProductInfo, [])
      }
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false, variantId) {
      const params = []
      const finalUrl = this.constructProductUrl(url)

      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`)

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`)
      }

      if (variantId) {
        params.push(`variant=${variantId}`)
      }

      return `${finalUrl}?${params.join('&')}`
    }

    keepSize(productId) {
      let size = this.dataset.selectedSize
      if (!size) return

      let productFound = this.jsonData.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this.jsonData.singles_data_json.find((product) => product.id === productId)
      }
      if (!productFound) {
        productFound = this.jsonData.families_data_json.find((product) => product.id === productId)
      }
      if (!productFound) {
        productFound = this.jsonData.alternative_length_family_data_json.find(
          (product) => product.id === productId,
        )
      }
      if (!productFound) return

      const variantFound = productFound.variants.find((variant) => variant.title === size)
      if (!variantFound) return

      return variantFound.id
    }

    updateProductPriceFromInputData(target) {
      const priceWrapper = this.querySelector('.js-product-price')
      if (!priceWrapper) return

      // const isClearance = target.dataset.isClearance === 'true'
      // const isPromo = target.dataset.isPromo === 'true'
      // const isWeeklyDeal = target.dataset.isWeeklyDeal === 'true'
      // console.log(
      //   'isPromo',
      //   target.dataset.isPromo,
      //   'isWeeklyDeal',
      //   target.dataset.isWeeklyDeal,
      //   'isClearance',
      //   target.dataset.isClearance,
      // )
      const price = target.dataset.productPrice
      const compareAtPrice = target.dataset.compareAtPrice
      this.dataset.productDiscount = this.calculateDiscount(price, compareAtPrice)

      // Handled by section rendering so discounted_price can be used
      /*
      let priceHtml = ''
      // Only show compare price and discount if there's an actual price difference
      if (
        compareAtPrice &&
        this.extractPrice(compareAtPrice) > this.extractPrice(price) &&
        !isClearance
      ) {
        priceHtml = `
          <div class="liquid-pdp__price liquid-pdp__price--full">
            <span class="visually-hidden">Regular price!</span>
            <s>${this.addSpaceToPrice(compareAtPrice)}</s>
          </div>

          <div class="liquid-pdp__price">
            <span class="visually-hidden">Discounted price</span>
            <span>${this.addSpaceToPrice(price)}</span>
          </div>

          ${this.showFreeShippingBadge(this.extractPrice(price)) ? '<div class="liquid-pdp__price-badges"><div class="badge free-shipping"><span>Free Shipping</span></div></div>' : ''}

          ${!isClearance ? '<span class="single-quote"><strong>Get up to 3 FREE items below.</strong></span>' : ''}
        `
      } else {
        priceHtml = `
          <div class="liquid-pdp__price">
            <span class="visually-hidden">Price</span>
            <span>${this.addSpaceToPrice(isClearance ? compareAtPrice : price)}</span>
          </div>
          ${this.showFreeShippingBadge(this.extractPrice(price)) ? '<div class="liquid-pdp__price-badges"><div class="badge free-shipping"><span>Free Shipping</span></div></div>' : ''}
          ${!isClearance ? '<span class="single-quote"><strong>Get up to 3 FREE items below.</strong></span>' : ''}
        `
      }

      priceWrapper.innerHTML = priceHtml
      */

      const selectedPackSize = this.querySelector('product-pack-selector input:checked')
      if (selectedPackSize) {
        const packSize = Number(selectedPackSize.dataset.size)
        const newPrice = this.toFixedTruncate(this.extractPrice(price) / packSize)
        const decimalSeparator = this.detectDecimalSeparator(price)
        let formattedPrice = newPrice
        if (decimalSeparator === ',') {
          formattedPrice = newPrice.replace('.', ',') // For EU: "480.16" → "480,16"
        }

        // selectedPackSize.parentNode.querySelector('small').innerHTML =
        //   `${this.symbol}${this.symbol === 'MX$' ? ' ' : ''}${formattedPrice}/item`
      }
    }

    calculateDiscount(price, compareAtPrice) {
      const priceValue = this.extractPrice(price)
      const compareAtPriceValue = this.extractPrice(compareAtPrice)
      return Math.round(((compareAtPriceValue - priceValue) / compareAtPriceValue) * 100)
    }

    extractPrice(priceString) {
      // Step 1: Standardize European format (1.234,56 → 1234.56)
      let standardized = priceString.replace(/[^\d,.-]/g, '') // Remove non-numeric except commas/dots

      // Step 2: Detect if comma is used as decimal separator (EU style)
      const lastComma = standardized.lastIndexOf(',')
      const lastDot = standardized.lastIndexOf('.')

      if (lastComma > lastDot) {
        // EU format (e.g., "1.234,56" or "89,99")
        standardized = standardized.replace(/\./g, '') // Remove thousand separators
        standardized = standardized.replace(',', '.') // Convert decimal comma to dot
      } else if (lastDot > lastComma) {
        // USD/Standard format (e.g., "1,234.56" or "89.99")
        standardized = standardized.replace(/,/g, '') // Remove thousand separators
      }
      // If no commas/dots, leave as-is (e.g., "8999" → 8999)

      return parseFloat(standardized)
    }

    addSpaceToPrice(priceString) {
      // Return early if no price string
      if (!priceString || typeof priceString !== 'string') return priceString

      // Match multi-character currency codes followed by symbol (CA$, MX$, US$, etc.)
      const multiCharMatch = priceString.match(/^([A-Z]{2,3})(\$)/i)

      if (multiCharMatch) {
        const countryCode = multiCharMatch[1]
        const symbol = multiCharMatch[2]
        const remainingString = priceString.slice(countryCode.length + symbol.length)

        // If there's already a space before the symbol, return as-is
        if (priceString.includes(`${countryCode} ${symbol}`)) return priceString

        // Add space before the symbol
        return `${countryCode} ${symbol}${remainingString}`
      }

      // For single character currencies ($, €, £, etc.), return unchanged
      return priceString
    }

    detectDecimalSeparator(priceString) {
      // Remove all non-numeric/separator characters (keep commas and dots)
      const cleanStr = priceString.replace(/[^\d,.]/g, '')

      // Find the last non-digit character (either comma or dot)
      for (let i = cleanStr.length - 1; i >= 0; i--) {
        const char = cleanStr[i]
        if (char === ',' || char === '.') {
          // Check if it's followed by exactly 2 digits (cents)
          const nextChars = cleanStr.slice(i + 1)
          return /^\d{2}$/.test(nextChars) ? char : 'unknown'
        }
      }

      // Fallback: No separator found → guess based on currency symbol
      return /[€£]/.test(priceString) ? ',' : '.'
    }

    showFreeShippingBadge(price) {
      const freeShippingThreshold = parseFloat(this.dataset.freeShippingThreshold || 0)
      return this.dataset.country === 'US' && price >= freeShippingThreshold
    }

    sendDataLayerInfo() {
      const packSize = this.dataset.productPackSize
      const pdpType = this.dataset.pdpType
      let cartSource

      if (pdpType === 'popup') {
        cartSource = 'Quick View'
      } else {
        cartSource = packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack'
      }

      window.dataLayer = window.dataLayer || []
      dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'view_item',
        cart_source: cartSource,
        ...window.intelligemsMeta,
        membership_status: this.dataset.membershipStatus,
        userId: this.dataset.customerId || null,
        page_type: 'Product Detail Page',
        color_pack: this.dataset.colorPack,
        login_status: this.dataset.loginStatus,
        pdp_type: this.dataset.pdpType,
        pack_quantity: this.dataset.packQuantity,
        ecommerce: {
          currency: this.dataset.ecommerceCurrency,
          value: Number(this.dataset.productPrice),
          items: [
            {
              item_id: Number(this.dataset.productId),
              cart_source: cartSource,
              item_name: this.dataset.productTitle,
              coupon: '',
              discount: Number(this.dataset.productDiscount),
              index: 1,
              item_brand: this.dataset.productBrand,
              item_category: this.dataset.productCategory,
              item_category2: this.dataset.productCategory2,
              item_category3: Number(this.dataset.productCategory3),
              item_category4: this.dataset.selectedSize,
              item_category5: this.dataset.productCategory5,
              item_list_id: '',
              item_list_name: '',
              item_variant: this.dataset.colorPack,
              price: Number(this.dataset.productPrice),
              quantity: 1,
              style_number: this.dataset.styleNumber ? this.dataset.styleNumber : '',
              sku_id: this.dataset.sku ? this.dataset.sku : '',
              variant_id: this.dataset.variantId ? this.dataset.variantId : '',
            },
          ],
        },
      })
    }

    toFixedTruncate(value, decimals = 2) {
      const factor = 10 ** decimals
      // Multiply, truncate, then divide to force 2 decimal places
      return (Math.trunc(value * factor) / factor).toFixed(decimals)
    }

    updateCuratedPacksSoldOutOverlay() {
      if (this.dataset.noPdpAppData === 'true') return

      const productColorsButtons = this.querySelector('.liquid-pdp__product-colors-buttons')
      const buttons =
        productColorsButtons?.querySelectorAll('.liquid-pdp__product-colors-button-wrapper') ?? []

      if (buttons.length === 0) return

      const allSoldOut = [...buttons].every((btn) => {
        const input = btn.querySelector('input')
        return input?.classList.contains('disabled')
      })

      const allSoldOutOverlay = this.querySelector(
        '.liquid-pdp__product-colors-buttons__all-sold-out-overlay',
      )
      if (allSoldOutOverlay) {
        allSoldOutOverlay.classList.toggle('hide', !allSoldOut)
      }

      // Event listeners are now handled via delegation at product-info level
      // Just ensure visibility is properly updated (Pima only with setting enabled)
      if (
        (this.dataset.familyHandle === 'short-sleeve-pima-crew' ||
          this.dataset.familyHandle === 'short-sleeve-curved-hem-pima-crew' ||
          this.dataset.familyHandle === 'long-sleeve-classic-crew') &&
        this.dataset.hideSoldOutPacksOnPimaPdp === 'true'
      ) {
        const productColors = this.querySelector('product-colors')
        if (productColors && productColors.updatePackVisibility) {
          productColors.updatePackVisibility()
        }
      }
    }

    updateStyleSelectionWithJs(target) {
      const selectedLabel = target.closest('label')
      if (!selectedLabel) return
      const selectedStyleText = selectedLabel.querySelector('span').textContent
      const closestProductStyle = target.closest('product-style')
      if (!closestProductStyle) return
      closestProductStyle.querySelector('h3 strong').textContent = selectedStyleText
    }

    updateBelowAtcModals(html) {
      const belowAtcModals = html.querySelector('.below-a2c-modals')
      if (belowAtcModals && this.belowAtcModals) {
        HTMLUpdateUtility.viewTransition(this.belowAtcModals, belowAtcModals, [])
      }
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.section
    }

    get variantSelectors() {
      return this.querySelector('variant-selects')
    }

    get productColors() {
      return this.querySelector('product-colors')
    }

    get productFamily() {
      return this.querySelector('product-style.family-selector')
    }

    get productFabric() {
      return this.querySelector('product-style.fabric-selector')
    }

    get productType() {
      return this.querySelector('product-type-selector')
    }

    get packSelectors() {
      return this.querySelector('product-pack-selector')
    }

    get productTitle() {
      return this.querySelector('.js-product-title')
    }

    get productDescription() {
      return this.querySelector('.js-product-description')
    }

    get productStarRating() {
      return this.querySelector('.js-product-star-rating')
    }

    get productPrice() {
      return this.querySelector('.js-product-price')
    }

    get tallEquivalent() {
      return this.querySelector('.js-tall-equivalent')
    }

    get productForm() {
      return this.querySelector('product-form')
    }

    get collapsibleWrapper() {
      return this.querySelector('.liquid-pdp__collapsible-wrapper')
    }

    get afterpay() {
      return this.querySelector('.afterpay-widget')
    }

    get productGallery() {
      return this.querySelector('product-gallery')
    }

    get jsonData() {
      const jsonDataContext = this.querySelector('.js-pdp-product-context-json')
      if (!jsonDataContext) return null
      return JSON.parse(jsonDataContext.textContent)
    }

    get selectedSize() {
      return (
        Array.from(this.querySelectorAll('variant-selects input:checked'))
          .map((input) => input.value)
          .join(' / ') || null
      )
    }

    get selectedPackSize() {
      return this.querySelector('product-pack-selector input:checked')?.dataset.size || null
    }

    get insidersPrice() {
      return this.querySelector('.js-insiders-price')
    }

    get belowPdpAppContent() {
      return document.querySelector('below-pdp-app-content')
    }

    get modalWrapper() {
      return this.querySelector('.pdp-modal-wrapper')
    }

    get sizeChart() {
      return document.querySelector('#modal-size-chart')
    }

    get discountBarProductPrice() {
      const price = this.querySelector('discount-bar .js-discount-price')
      if (!price) return null
      return price
    }

    get pdpProductContext() {
      return this.querySelector('pdp-product-context')
    }

    get productUso() {
      return this.querySelector('product-uso')
    }

    get uiFooter() {
      return this.querySelector('.js-liquid-pdp__ui-footer')
    }

    get bxgyPrice() {
      return this.querySelector('.js-bxgy-price')
    }

    get bxgyWrapper() {
      return this.querySelector('.js-bxgy-wrapper')
    }

    get productCustomPack() {
      return this.querySelector('product-custom-pack')
    }

    get sizeChartButton() {
      return this.querySelector('.js-size-chart-button-wrapper')
    }

    get sizeChartModal() {
      return this.querySelector('size-chart-modal')
    }

    get availableInTarget() {
      return this.querySelector('available-in-target')
    }

    get productDescription() {
      return this.querySelector('.js-product-description')
    }

    get discountBar() {
      return this.querySelector('discount-bar')
    }

    get bundleBuilderQuantitySelector() {
      return this.querySelector('bundle-builder-quantity-selector')
    }

    get belowAtcModals() {
      return this.querySelector('.below-a2c-modals')
    }

    get completeTheLook() {
      return this.querySelector('.js-complete-the-look')
    }

    get expectedShipping() {
      return this.querySelector('.js-expected-shipping')
    }

    openBxgyPopup() {
      const modal = document.querySelector('image-modal')
      if (modal) {
        modal.querySelector('.js-image').src = this.bxgyWrapper.dataset.popupImage
        modal.querySelector('.js-image-link').href = this.bxgyWrapper.dataset.popupLink
        modal.querySelector('.js-image-link').dataset.closePopup =
          this.bxgyWrapper.dataset.closePopup
        modal.openImageModal()
      }
    }

    /**
     * Set up pay-later modal functionality
     * Listens for clicks on .pay-later-wrapper.js-modal-trigger elements
     * and triggers the dynamic-modal's renderDynamicModalIframe function
     */
    setupPayLaterModal() {
      // Add click event listener to the product-info element for event delegation
      this.addEventListener('click', (event) => {
        const target = event.target.closest('.pay-later-wrapper.js-modal-trigger')
        if (!target) return
        event.preventDefault()

        // Find the dynamic-modal element
        const dynamicModal = document.querySelector('dynamic-modal')
        if (!dynamicModal) {
          console.warn('Dynamic modal element not found')
          return
        }

        // Call the renderDynamicModalIframe function with the configuration
        dynamicModal.renderDynamicModalIframe({
          modalId: 'afterpay-modal',
          iframeUrl: 'https://static.afterpay.com/modal/en_US.html',
          iframeHeight: '800',
          iframeWidth: '400',
          iframeHeightMobile: '800',
          iframeWidthMobile: '400',
        })
      })
    }
  }
  customElements.define('product-info', ProductInfo)
}

if (!customElements.get('discount-bar')) {
  class DiscountBar extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      // if (logPDP) console.log('%c discount-bar connectedCallback', 'color: pink;')
      if (logPDP && this.dataset.isClearance === 'true')
        return console.log('isClearance: do nothing')

      this.productInfo = this.closest('product-info')
      this.promoBar = this.querySelector('.liquid-pdp__discount-bar--promo-bar')
      this.promoButton = this.querySelector('.liquid-pdp__discount-bar--promo-button')
      this.text = this.querySelector('.js-discount-text')
      this.appliedText = this.querySelector('.js-discount-bar--applied-text')
      this.symbol = this.dataset.currencySymbol
      this.isWeeklyDeal = this.dataset.isWeeklyDeal === 'true'
      this.useMetaobjectPromo = this.dataset.useMetaobjectPromo === 'true'

      if (this.isWeeklyDeal || this.useMetaobjectPromo) {
        const promoBar = this.promoBar
        const discountButton = this.promoButton
        const appliedText = this.appliedText
        const code = this.dataset.discountCodeName
        promoBar.addEventListener('click', applyDiscountCode)

        async function applyDiscountCode() {
          const resetAppliedText = () => setTimeout(() => (appliedText.textContent = ''), 1500)

          navigator.clipboard.writeText(code)

          discountButton.classList.add('checked')
          promoBar.style.pointerEvents = 'none'
          promoBar.style.cursor = 'default'

          appliedText.textContent = 'Applied!'

          try {
            const response = await fetch(`${window.Shopify.routes.root}discount/${code}`, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            })

            if (response.ok) {
              document.dispatchEvent(
                new CustomEvent('cartaddsuccess', {
                  detail: { openCart: false, refreshCart: true },
                }),
              )
              resetAppliedText()
            } else {
              resetAppliedText()
            }
          } catch (error) {
            console.error('ERR:', error)
            resetAppliedText()
          }
        }
      }

      // window.addEventListener('resize', this.hideAppliedTextOnSmallScreens.bind(this))
    }

    // disconnectedCallback() {
    //   window.removeEventListener('resize', this.hideAppliedTextOnSmallScreens.bind(this))
    // }

    hideAppliedTextOnSmallScreens() {
      const discountBar = this.querySelector('.liquid-pdp__discount-bar')

      if (!discountBar || !this.appliedText) return

      if (discountBar.offsetWidth > window.innerWidth * 0.6) {
        this.appliedText.classList.add('hidden')
      } else {
        this.appliedText.classList.remove('hidden')
      }
    }
  }

  customElements.define('discount-bar', DiscountBar)
}

if (!customElements.get('klaviyo-notify-me')) {
  class KlaviyoNotifyMe extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.form = this.querySelector('form')
      this.button = this.querySelector('button')
      this.emailInput = this.querySelector('input')
      this.successMessage = this.querySelector('.js-success-message')
      this.form.addEventListener('submit', async (event) => {
        event.preventDefault()

        this.button.classList.add('loading')
        this.emailInput.setAttribute('disabled', true)
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.emailInput.setCustomValidity('Please enter a valid email address')
          this.emailInput.reportValidity()
          return
        }

        this.emailInput.setCustomValidity('')

        const variantId = this.form.querySelector('input[name="variant_id"]').value
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${email}`,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }

        const response = await fetch(
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Lj2344',
          options,
        )
        if (response) {
          this.successMessage.classList.remove('visually-hidden')
          this.form.classList.add('visually-hidden')
        }
        this.button.classList.remove('loading')
        this.emailInput.removeAttribute('disabled')
        this.querySelector('.loading__spinner').classList.add('hidden')
      })

      // Add input validation on email changes
      this.emailInput.addEventListener('input', () => {
        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.button.setAttribute('disabled', true)
          this.emailInput.setCustomValidity('Please enter a valid email address')
        } else {
          this.button.removeAttribute('disabled')
          this.emailInput.setCustomValidity('')
        }
      })
    }
  }
  customElements.define('klaviyo-notify-me', KlaviyoNotifyMe)
}

if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    oldText = ''

    constructor() {
      super()
      this.observer = null
      this.mutationObserver = null
      this.productForm = null
    }

    connectedCallback() {
      this.init()
      this.setupMutationObserver()
    }

    setupMutationObserver() {
      this.mutationObserver = new MutationObserver((mutations) => {
        // Check if the product form was removed and re-added
        const productForm = document.querySelector('product-form')
        if (productForm !== this.productForm) {
          this.cleanupObserver()
          this.init()
        }
      })

      // Observe the entire document for changes to product-form
      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      })
    }

    cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    }

    init() {
      this.productForm = document.querySelector('product-form')
      if (!this.productForm) return

      this.button = this.querySelector('button')
      this.button.addEventListener('click', () => {
        const targetElement = document.querySelector('.liquid-pdp__header')
        const selectedVariant = document.querySelector('variant-selects input:checked')
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 87
          targetElement.scrollIntoView({ top: offsetTop, behavior: 'smooth' })

          if (selectedVariant) {
            this.oldText = this.button.textContent
            this.button.textContent = 'Adding to Cart...'
            document.querySelector('product-form button[type="submit"]').click()
            setTimeout(() => {
              this.button.textContent = this.oldText
            }, 1500)
          }
        }
      })

      // Set up the Intersection Observer
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const rect = entry.boundingClientRect
            // Show only after the entire product form has left the viewport (scrolled past the bottom)
            if (!entry.isIntersecting && rect.bottom <= 0) this.classList.remove('hidden')
            else this.classList.add('hidden')
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        },
      )

      // Start observing the product form
      this.observer.observe(this.productForm)
    }

    disconnectedCallback() {
      // Clean up both observers when the element is removed
      this.cleanupObserver()
      if (this.mutationObserver) {
        this.mutationObserver.disconnect()
        this.mutationObserver = null
      }
    }
  }
  customElements.define('sticky-add-to-cart', StickyAddToCart)
}

if (!customElements.get('product-custom-pack')) {
  class ProductCustomPack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addToBundle = this.querySelector('[name="add-item-to-bundle"]')
      this.addBundleToCart = this.querySelector('[name="add-bundle-to-cart"]')

      if (this.addToBundle !== null) {
        this.addToBundle.addEventListener('click', (event) => {
          const selectedCheckbox = this.querySelector('input:checked')
          const featuredImage = selectedCheckbox.dataset.featuredImage
          const variantId = selectedCheckbox.dataset.variantId
          const cartItem = this.querySelector('.liquid-pdp__custom-pack-cart-item:not(.selected)')
          cartItem.setAttribute('data-variant-id', variantId)
          cartItem.style.backgroundImage = `url(${featuredImage})`
          cartItem.classList.add('selected')
        })
      }

      if (this.addBundleToCart !== null) {
        this.addBundleToCart.addEventListener('click', (event) => {
          let formData = {
            items: [
              {
                id: 40592815030344,
                quantity: 1,
                properties: {
                  _variantIds: '29275989082184x7<>29275946877000x5',
                },
              },
            ],
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json()
            })
            .catch((error) => {
              console.error('Error:', error)
            })
        })
      }
    }
  }
  customElements.define('product-custom-pack', ProductCustomPack)
}

if (!customElements.get('open-size-chart')) {
  class OpenSizeChart extends HTMLElement {
    optionName = null
    constructor() {
      super()
    }

    connectedCallback() {
      this.optionName = this.dataset.optionName || null
      this.init()
    }

    init() {
      this.addEventListener('click', () => {
        const sizeChartModal = document.querySelector('size-chart-modal')
        if (sizeChartModal) {
          sizeChartModal.optionName = this.optionName
          sizeChartModal.open()
        }
      })
    }
  }
  customElements.define('open-size-chart', OpenSizeChart)
}

if (!customElements.get('open-compare-modal')) {
  class OpenCompareModal extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.addEventListener('click', () => {
        const compareModal = document.querySelector('compare-modal')
        const style = this.dataset.style
        if (compareModal) {
          compareModal.open(style)
        }
      })
    }
  }
  customElements.define('open-compare-modal', OpenCompareModal)
}

/**
 *
 * GLOBALS (Replace this on the new theme)
 *
 */

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

function handleNotReturningSwatches() {
  const first_color = document.querySelector('product-colors input')
  const product_color = document.querySelector('product-colors input:checked')
  if (!first_color || !product_color) return

  if (product_color.dataset.notReturning === 'true' && product_color.dataset.disabled === 'true') {
    first_color.click()
  }
}

function dataLayerPageView() {
  const productInfo = document.querySelector('product-info')
  if (!productInfo) return
  const packSize = productInfo.dataset.productPackSize
  let cartSource
  if (productInfo.dataset.pdpType === 'popup') {
    cartSource = 'Quick View'
  } else {
    cartSource = packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack'
  }
  window.dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'view_item',
    cart_source: cartSource,
    membership_status: productInfo.dataset.membershipStatus,
    ...window.intelligemsMeta,
    userId: productInfo.dataset.customerId || null,
    page_type: 'Product Detail Page',
    color_pack: productInfo.dataset.colorPack,
    login_status: productInfo.dataset.loginStatus,
    pdp_type: productInfo.dataset.pdpType,
    pack_quantity: productInfo.dataset.packQuantity,
    ecommerce: {
      currency: productInfo.dataset.ecommerceCurrency,
      value: Number(productInfo.dataset.productPrice),
      items: [
        {
          item_id: Number(productInfo.dataset.productId),
          cart_source: cartSource,
          item_name: productInfo.dataset.productTitle,
          coupon: '',
          discount: Number(productInfo.dataset.productDiscount),
          index: 1,
          item_brand: productInfo.dataset.productBrand,
          item_category: productInfo.dataset.productCategory,
          item_category2: productInfo.dataset.productCategory2,
          item_category3: Number(productInfo.dataset.productCategory3),
          item_category4: productInfo.dataset.selectedSize,
          item_category5: productInfo.dataset.productCategory5,
          item_list_id: '',
          item_list_name: '',
          item_variant: productInfo.dataset.colorPack,
          price: Number(productInfo.dataset.productPrice),
          quantity: 1,
          style_number: productInfo.dataset.styleNumber ? productInfo.dataset.styleNumber : '',
          sku_id: productInfo.dataset.sku ? productInfo.dataset.sku : '',
          variant_id: productInfo.dataset.variantId ? productInfo.dataset.variantId : '',
        },
      ],
    },
  })
}

// Handle update of Insider Upsell on cart changes
window.addEventListener('DOMContentLoaded', () => {
  handleNotReturningSwatches()
  // checkShortSize()

  document.addEventListener('cartaddsuccess', handleCartUpdate)
  document.addEventListener('cartremovesuccess', handleCartUpdate)
  document.addEventListener('cartupdatesuccess', handleCartUpdate)
  document.addEventListener('cartmembershipaddsuccess', handleCartUpdate)

  async function handleCartUpdate() {
    const productInfo = document.querySelector('product-info')
    if (!productInfo) return

    const dataUrl = productInfo.dataset.url
    if (!dataUrl) return

    try {
      const response = await fetch(`${dataUrl}?view=pdp-liquid-quick-add`)
      const htmlSection = await response.text()
      const html = new DOMParser().parseFromString(htmlSection, 'text/html')
      updateInsiderClubUpsell(html)
      updateCashbackMessage(html)
      checkRivoCashbackProfile()
    } catch (e) {
      console.error(e)
    }
  }
})

// Check for active auto-applicable promo and apply it
// window.addEventListener('DOMContentLoaded', () => {
//   const promoBar = document.querySelector('.liquid-pdp__discount-bar-wrapper')
//   if (!promoBar) return

//   const { autoApplyDiscount, isWeeklyDeal, useMetaobjectPromo, discountCodeName } = promoBar.dataset

//   if (autoApplyDiscount !== 'true') return

//   if (isWeeklyDeal === 'true' || useMetaobjectPromo === 'true')
//     applyDiscountCode({ code: discountCodeName })
// })

async function applyDiscountCode(args = {}) {
  const { code, openCart = false, refreshCart = true } = args
  if (!code) return

  try {
    const response = await fetch(`${window.Shopify.routes.root}discount/${code}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    if (response.ok) {
      document.dispatchEvent(
        new CustomEvent('cartaddsuccess', {
          detail: { openCart, refreshCart },
        }),
      )
      console.log('promo applied')
    }
  } catch (error) {
    console.error('ERR:', error)
  }
}

function updateInsiderClubUpsell(html) {
  const insiderUpsell = html.querySelector('.js-insider-club-upsell')
  const current = document.querySelector('.js-insider-club-upsell')
  if (insiderUpsell && current) {
    HTMLUpdateUtility.viewTransition(current, insiderUpsell, [])
  }
}

function updateCashbackMessage(html) {
  const cashbackMessage = html.querySelector('cashback-message')
  const current = document.querySelector('cashback-message')
  if (cashbackMessage && current) {
    HTMLUpdateUtility.viewTransition(current, cashbackMessage, [])
  }
}

function updateGalleryPromoText(html) {
  const promoText = html.querySelector('.gallery-promo-text-overlay')
  const current = document.querySelector('.gallery-promo-text-overlay')
  if (promoText && current) {
    HTMLUpdateUtility.viewTransition(current, promoText, [])
  }
}

/**
 * Grab the OKE "rating-distribution" block from the page,
 * convert the counts ("51.2k" → 51200, "3k" → 3000, plain numbers as-is),
 * and return an array sorted from 1-star up to 5-star.
 * @returns {{rating: number, reviews: number}[]}
 */

function getRatingBreakdown(scope = document) {
  const block = scope.querySelector('.oke-w-breakdownModule-distribution')
  if (!block) return null

  const ratings = [...block.querySelectorAll('.oke-w-breakdownModule-distribution-label-number')]
  const counts = [...block.querySelectorAll('.oke-w-breakdownModule-distribution-count')]

  const toNumber = (txt) => {
    const clean = txt.trim().toLowerCase().replace(/,/g, '')
    if (clean.endsWith('k')) return Math.round(parseFloat(clean) * 1_000)
    if (clean.endsWith('m')) return Math.round(parseFloat(clean) * 1_000_000)
    return parseInt(clean, 10)
  }

  const data = ratings.map((rEl, i) => ({
    rating: parseInt(rEl.textContent.trim(), 10),
    reviews: toNumber(counts[i]?.textContent || '0'),
  }))

  if (data.length === 0) return null

  // Defensive: sort in case the markup isn't already 1→5 or 5→1
  return data.sort((a, b) => a.rating - b.rating)
}

document.addEventListener('DOMContentLoaded', () => updateOkendoReviewsRecommendations())

function updateOkendoReviewsRecommendations() {
  let count = 0
  const ratingTimeout = setInterval(() => {
    count++

    if (count > 10) {
      clearInterval(ratingTimeout)
      return
    }

    const ratingBreakdown = getRatingBreakdown()

    if (ratingBreakdown) {
      clearInterval(ratingTimeout)
      const ratingPercentage = percentAbove(ratingBreakdown)
      const recWrappers = document.querySelectorAll('.liquid-pdp__reviews-recommendations')
      if (recWrappers.length > 0) {
        recWrappers.forEach((recWrapper) => {
          const recPercentage = recWrapper.querySelector(
            '.liquid-pdp__reviews-recommendations-percentage',
          )
          if (recPercentage && ratingPercentage > 55) {
            recPercentage.innerHTML = `<span>${ratingPercentage}%</span>`
            recWrapper.classList.remove('hidden')
          }
        })
      }
    }
  }, 1000)
}

/**
 * Return % of reviews with rating ≥ threshold.
 * @param {Array<{rating:number, reviews:number}>} dist - e.g. [{rating:1,reviews:3000}, …]
 * @param {number} threshold - default 3.5
 * @returns {number} percentage, 0-100
 */
function percentAbove(dist, threshold = 3) {
  const total = dist.reduce((sum, { reviews }) => sum + reviews, 0)
  if (!total) return 0 // guard against empty / zero totals
  const qualifying = dist
    .filter(({ rating }) => rating >= threshold)
    .reduce((sum, { reviews }) => sum + reviews, 0)
  return Math.round((qualifying / total) * 100)
}

function logProductInfoDataAttributes() {
  if (!logPDP) return
  const productInfo = document.querySelector('product-info')
  if (!productInfo) return
}

if (logPDP) document.addEventListener('DOMContentLoaded', logProductInfoDataAttributes)
